// src/modules/goldInventory/routes.jsx
import { Routes, Route } from 'react-router-dom';
import InventoryDashboard from './pages/InventoryDashboard';
import BatchDetails from './pages/BatchDetails';
import InvoiceSettings from './pages/InvoiceSettings';

function GoldInventoryRoutes() {
  return (
    <Routes>
      <Route path="/" element={<InventoryDashboard />} />
      <Route path="/invoice-settings" element={<InvoiceSettings />} />
      <Route path="/:id" element={<BatchDetails />} />
    </Routes>
  );
}

export default GoldInventoryRoutes;
